export enum CompanyId {
    ALL = "ALL",
    RWS = "RWS"
}
